/**
 * Утилиты для форматирования имени пользователя
 *
 * Два режима:
 * - Полный: "Имя Фамилия"
 * - Сокращённый: "Имя Ф." (для компактных блоков)
 */

/**
 * Форматирует имя пользователя из отдельных полей firstName / lastName
 *
 * @param firstName — имя (display_name в БД)
 * @param lastName  — фамилия (опционально)
 * @param options.short — сокращать фамилию до первой буквы ("Имя Ф.")
 * @returns отформатированная строка или пустая строка, если имя не задано
 *
 * @example
 * formatUserName('Анна', 'Крылова')              // "Анна Крылова"
 * formatUserName('Анна', 'Крылова', { short: true }) // "Анна К."
 * formatUserName('Анна', null)                    // "Анна"
 * formatUserName(null, null)                      // ""
 */
export function formatUserName(
  firstName: string | null | undefined,
  lastName: string | null | undefined,
  options?: { short?: boolean },
): string {
  const first = firstName?.trim();
  const last = lastName?.trim();

  if (!first) return '';
  if (!last) return first;

  if (options?.short) {
    return `${first} ${last[0].toUpperCase()}.`;
  }

  return `${first} ${last}`;
}
